import React from "react";

interface TypeProps {
  data: any;
  Auth: any;
}

const Types: React.FC<TypeProps> = ({ data, Auth }) => {
  
  return (
    <div className="flex flex-col gap-2">
      <div>
        <div className="flex flex-col gap-2">
          <h4 className="text-lg font-normal">Building</h4>
          <hr />
          <div className="flex flex-wrap gap-5">
            <div className="flex flex-col gap-2 md:w-1/5">
              <h4 className="text-base font-normal">Bedrooms</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.BedroomsTotal || "--"}
              </p>
            </div>
            <div className="flex flex-col gap-2 md:w-1/5">
              <h4 className="text-base font-normal">Bathrooms</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.BathroomsTotalInteger || "--"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="flex flex-col gap-2 flex-wrap">
          <h4 className="text-lg font-normal">Utilities</h4>
          <hr />
          <div className="flex flex-wrap gap-5">
            <div className="flex flex-col gap-2 md:w-1/5">
              <h4 className="text-base font-normal">Water</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >

                {data.Water && data.Water.replaceAll("[", "")
                  .replaceAll("]", "")
                  .replaceAll("'", "") || "--"}
              </p>
            </div>
            <div className="flex flex-col gap-2 md:w-1/5">
              <h4 className="text-base font-normal">Sewer</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.Sewer && data.Sewer || data.SewerYN }
              </p>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="flex flex-col gap-2 flex-wrap">
          <h4 className="text-lg font-normal">Features</h4>
          <hr />
          <div className="flex flex-wrap gap-5">
            <div className="flex flex-col gap-2 md:w-1/5">
              <h4 className="text-base font-normal">Kitchen</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.KitchensTotal || "--"}
              </p>
            </div>
            <div className="flex flex-col gap-2 md:w-1/5">
              <h4 className="text-base font-normal">Family Room</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.DenFamilyroomYN ? "Yes" : "No" }
              </p>
            </div>
            <div className="flex flex-col gap-2 md:w-1/5">
              <h4 className="text-base font-normal">Basement</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.Basement.map((basement: string) => basement).join(", ") || "--"}
              </p>
            </div>
            <div className="flex flex-col gap-2 md:w-1/5">
              <h4 className="text-base font-normal">Fireplace</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.FireplaceYN ? "Yes" : "No"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-4">
        <div className="flex flex-col gap-2 flex-wrap">
          <h4 className="text-lg font-normal">External Features</h4>
          <hr />
          <div className="flex gap-5">
            <div className="flex flex-col gap-2 ">
              <h4 className="text-base font-normal">External Finish</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.ConstructionMaterials}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-4">
        <div className="flex flex-col gap-2 flex-wrap">
          <h4 className="text-lg font-normal">Property Features</h4>
          <hr />
          <div className="flex gap-5">
            <div className="flex gap-2">
              <span
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.PropertyFeatures.map((feature: string) => feature).join(", ")}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-4">
        <div className="flex flex-col gap-2">
          <h4 className="text-lg font-normal">Cooling And Heating</h4>
          <hr />
          <div className="flex flex-wrap gap-2 md:gap-0 w-full ">
            <div className="flex flex-col gap-2 md:w-1/5 w-full">
              <h4 className="text-base font-normal">Cooling Type</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.Cooling || "--"}
              </p>
            </div>
            <div className="flex flex-col gap-2 md:w-1/5 w-full">
              <h4 className="text-base font-normal">Heating Type</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.HeatType|| "--"}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-4">
        <div className="flex flex-col gap-2">
          <h4 className="text-lg font-normal">Bungalows Information</h4>
          <hr />
          <div className="flex flex-wrap gap-5">
            <div className="flex flex-col gap-2">
              <h4 className="text-base ">Days On Market</h4>
              <p
                className={`text-sm text-justify ${
                  data.Lock && !Auth.verify ? "blur-sm" : ""
                }`}
              >
                {data.Dom || "0"} Days
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Types;
